import type { EmptyStateHandler, QuickInsertOptions } from '@atlaskit/editor-common/types';
import type { QuickInsertPluginOptions } from '@atlaskit/editor-plugin-quick-insert';

interface Props {
	options: {
		emptyStateHandler?: EmptyStateHandler | undefined;
		/**
		 * Pages whose element list is fixed (topic pages) offer no insertion at all,
		 * so quick insert goes headless: no `/` typeahead and no element browser.
		 */
		isTemplateLocked?: boolean;
		quickInsert?: QuickInsertOptions;
	};
}

export function quickInsertPluginOptions({ options }: Props): QuickInsertPluginOptions {
	const isTemplateLocked = Boolean(options?.isTemplateLocked);

	return {
		enableElementBrowser: !isTemplateLocked,
		elementBrowserHelpUrl: '',
		disableDefaultItems: isTemplateLocked,
		headless: isTemplateLocked,
		emptyStateHandler: options?.emptyStateHandler,
		prioritySortingFn:
			typeof options.quickInsert === 'object' ? options.quickInsert.prioritySortingFn : undefined,
		onInsert: typeof options.quickInsert === 'object' ? options.quickInsert.onInsert : undefined,
	};
}
